<template>
  <div :class="containerClasses">
    <!-- Overlay si demandé -->
    <div 
      v-if="overlay"
      class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center"
    >
      <div class="bg-white rounded-lg p-6 shadow-xl">
        <div class="flex items-center">
          <div :class="spinnerClasses"></div>
          <span 
            v-if="showText" 
            :class="textClasses"
          >
            {{ displayText }}
          </span>
        </div>
      </div>
    </div>
    
    <!-- Spinner normal -->
    <div v-else class="flex items-center">
      <div :class="spinnerClasses"></div>
      <span 
        v-if="showText" 
        :class="textClasses"
      >
        {{ displayText }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

export interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'primary' | 'secondary' | 'white';
  text?: string;
  showText?: boolean;
  centered?: boolean;
  overlay?: boolean;
}

const props = withDefaults(defineProps<LoadingSpinnerProps>(), {
  size: 'md',
  variant: 'primary',
  text: undefined,
  showText: true,
  centered: false,
  overlay: false,
});

// Classes computées
const containerClasses = computed((): string => {
  const baseClasses = 'flex items-center';
  
  if (props.centered) {
    return `${baseClasses} justify-center`;
  }
  
  return baseClasses;
});

const spinnerClasses = computed((): string => {
  const baseClasses = 'animate-spin rounded-full border-solid border-t-transparent';
  
  // Tailles
  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-6 h-6 border-2',
    lg: 'w-8 h-8 border-3',
    xl: 'w-12 h-12 border-4',
  };
  
  // Variants de couleur
  const variantClasses = {
    primary: 'border-blue-600',
    secondary: 'border-gray-600',
    white: 'border-white',
  };
  
  return [
    baseClasses,
    sizeClasses[props.size],
    variantClasses[props.variant],
  ].join(' ');
});

const textClasses = computed((): string => {
  const baseClasses = 'ml-3 text-sm font-medium';
  
  const variantClasses = {
    primary: 'text-gray-700',
    secondary: 'text-gray-600',
    white: 'text-white',
  };
  
  return `${baseClasses} ${variantClasses[props.variant]}`;
});

const displayText = computed((): string => {
  return props.text || 'Chargement...';
});
</script> 